export default __webpack_public_path__ + "static/media/icn-welcome-on.7b4fc706.svg";